const BASE_URL = 'notifications'

export default {
  GET_NOTIFICATIONS: `/${BASE_URL}`,
  GET_NOTIFICATION: `/${BASE_URL}`,
}
